<template>
    <div>
      <div class="row">
        <div class="col-2">
          <div class="listy">
            <div class="label"> Max. Bet Odd Value:</div>
            <input class="form-control" v-model="minBetOdd" type="number" />
          </div>
        </div>
        <div class="col-2">
          <div class="listy">
            <div class="label">Sport:</div>
            <autocomplete
              @clear="setSport"
              @selected="setSport"
              resultsDisplay="name"
              :source="sports">
            </autocomplete>
          </div>
        </div>
        <div class="col-8 text-right">
          <a href="javascript:;" class="btn btn-danger" @click="resetLadders"><i class="os-icon os-icon-rotate-cw"/> Reset</a>
          <a href="javascript:;" class="btn btn-success" v-on:click="saveSettings()"><i class="os-icon os-icon-save"/> Save</a>
        </div>
      </div>
      <div class="ladder-wrapper pt-2">
        <div class="placehoder-bg"></div>
        <div class="y">
          <ul class="percentageOfNumber">
            <li v-for="s in steps">
              %{{ s }}0
              <span class="pull-right">-</span>
            </li>
          </ul>
        </div>
        <div class="slider-item text-center">
          <div class="halfline"></div>
          <div class="slider-row" v-for="index in 20" :key="index">
            <input type="range" v-model="values[index - 1]" min="0" max="5500" orient="vertical" />
            <div class="label">
              {{ index }}
            </div>
            <div class="percentage">{{ parseInt(values[index - 1]) }}%</div>
          </div>
        </div>
        <div class="success-popup">
          <successWatermark v-if="formProcess == 200" />
        </div>
      </div>
    </div>
</template>

<script>
  import successWatermark from '@/components/ui/loader/successWatermark'
  import Autocomplete from 'vuejs-auto-complete'
  import feed from '@/mixins/feed.js'
  import templateSelector from '@/components/feed/element/templateSelector'
    export default {
      name: "ladder",
      mixins: [feed],
      components: {Autocomplete, successWatermark, templateSelector},
      data () {
        return {
          formProcess: 0,
          minBetOdd: 0,
          isLoading: true,
          sport: 0,
          sports: [],
          steps: [],
          values: [
            10, 20, 30, 40, 50, 60, 70, 80, 90, 100
          ],
          defaultValues: [
            0, 10, 20, 30, 40, 50, 60, 70, 80, 90
          ],
        }
      },
      mounted () {
        var i = 21;
        while(i--)
        {
          this.steps.push(i);
        }

        this.fetchSports().then(response => {
          this.sports = Object.values(response.body.result.sport);


        })

        this.fetchLadders()
      },
      methods: {
        setSport(s) {

          if(s)
            this.sport = s.selectedObject.id;

          if(!s)
            this.sport = 0;

            this.fetchLadders()
        },
        resetLadders() {

            this.values = this.defaultValues;
            this.saveSettings();
        },
        fetchLadders() {
          this.fetchBetRiskLadder({sport: this.sport}).then(response => {

              this.isLoading = false;
              this.minBetOdd = parseFloat(response.body.minBetOdd);

            if(response.body.steps)
              this.values = response.body.steps;


            }, response => {

              this.saved = false;
              this.isLoading = false;
            })
        },
        saveSettings() {
          this.isLoading = true;
          this.saveBetRiskLadder({steps: this.values,minBetOdd: this.minBetOdd, sport: this.sport}).then(
            response => {
              console.log(response)
            this.formProcess = 200;
            this.values = response.body.steps;
            this.minBetOdd = parseFloat(response.body.minBetOdd);
            this.isLoading = false;

            setTimeout(() => {
              this.formProcess = 0;
            }, 3000)
          })
        }
      }
    }
</script>

<style scoped>
.ladder-wrapper {
  position: relative;
  width: 100%;
  height: 60vh;
  display: flex;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.39);
}
.slider-item {
  display: flex;
  width: 90%;
  position: relative;
}
.slider-row {
  height: 100%;
  flex: 2 1 10%;
}
.y {
  width: 5%;
  height: 100%;
}
.percentage {
  color: #0275ff;
}
.percentageOfNumber {
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 11px;
  flex: 1
}
.percentageOfNumber > li {
  text-align: center;
  list-style: none;
  padding: none;
  width: 100%;
  height: 4.4%;
}
input[type=range][orient=vertical]
{
  writing-mode: bt-lr; /* IE */
  -webkit-appearance: slider-vertical; /* WebKit */
  width: 8px;
  height: 90%;
  padding: 0 5px;
}
.slider-row .label {
  font-size: 11px;
}
.placehoder-bg {
  z-index: -1;
  width: 100%;
  height: 100%;
  position: absolute;
  background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.25) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.25) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}
.halfline {
  top: 0;
  left: 0;
  width: 100%;
  height: 45%;
  border-bottom: 1px solid rgba(0,0,0,0.25);
  position: absolute;
  z-index: -1;
}

</style>



// WEBPACK FOOTER //
// src/components/feed/settings/ladder.vue